import { useEffect, useState } from "react";
import { Box, Drawer, IconButton, useMediaQuery } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { trackEventGA } from "../libs/analyticsManager";
import { useLoginState } from "../studioxr/auth/LoginState";
import { Bar } from "../auth/Bar";
import { HeroTitle } from "../design_stream/components/PromptForm/PromptFormView.styled";
import { stampPendingStartOptionsArm } from "./onboarding/startOptionsExperiment";
import { HomeSideBar, WS_EXPANDED_WIDTH } from "./HomeSideBar";
import { StartingCardsRow } from "./StartingCardsRow";

export const StartingOptions = () => {
  const isMobile = useMediaQuery("(max-width:900px)");
  const [drawerOpen, setDrawerOpen] = useState(false);

  const uid = useLoginState((state) => state.profile?.uid);

  useEffect(() => {
    trackEventGA("starting_options_view");
  }, []);

  // A new signup handed off by SignUp.tsx: stamp the arm now that they've
  // landed (waits for the profile — the stamp is a profile write).
  useEffect(() => {
    if (!uid) return;
    void stampPendingStartOptionsArm({
      uid,
      getUid: () => useLoginState.getState().profile?.uid,
      stampArm: (arm, experiment) =>
        (useLoginState.getState() as any).markOnboardingArm(arm, experiment),
    });
  }, [uid]);

  const sidebar = (
    <HomeSideBar
      selectedTab=""
      defaultCollapsed
      onNavigate={isMobile ? () => setDrawerOpen(false) : undefined}
    />
  );

  return (
    <Box
      sx={{
        height: "100vh",
        backgroundColor: "#fafafb",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Bar />
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        {isMobile ? (
          <Drawer
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{ sx: { width: WS_EXPANDED_WIDTH } }}
          >
            {sidebar}
          </Drawer>
        ) : (
          sidebar
        )}
        <Box
          sx={{
            flexGrow: 1,
            minWidth: 0,
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            padding: isMobile ? "16px" : "24px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* <h2>Remix Mode: {remixMode ? "true" : "false"}</h2> */}
          {isMobile && (
            <IconButton
              onClick={() => setDrawerOpen(true)}
              sx={{ mb: 1, alignSelf: "flex-start" }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box
            sx={{
              flexGrow: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <HeroTitle variant="h1" sx={{ mb: { xs: 2, md: 4 } }}>
              <span className="highlight">Design &amp; discover</span> with real
              products
            </HeroTitle>
            <StartingCardsRow
              onCardClick={(card) =>
                trackEventGA("starting_option_click", { card })
              }
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
